import { Component, HostListener, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { StandardQuestionModel } from '../../../models/standard-question.model';
import { Answer } from '../../../models/answer.model';
import { Question } from '../../../models/question.model';
import { AnsweredQuestions } from '../../../models/answered-questions.model';
import { QuestionWithAnswer } from '../../../models/question-with-answer.model';
import { Router } from '@angular/router';
import { TestingService } from '../../../services/testing.service';
import { SidebarService } from '../../../services/side-bar.service';
import { TaskBarService } from '../../../services/task-bar.service';
import { HeaderService } from '../../../services/header.service';
import { ViewDocxComponent } from '../view-docx/view-docx.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewDocxService } from '../../../services/view-docx.service';
import { TestingDataService } from './testing.service';
import { AdminService } from '../../../services/admin.service';
import { VectorValueComponent } from '../view-group/vector-value/vector-value.component';

@Component({
  selector: 'app-testing-page',
  templateUrl: './testing-page.component.html',
  styleUrls: ['./testing-page.component.css']
})

export class TestingPageComponent implements OnInit {

  leaveTesting = false;
  errorGetList = false;
  errorGetItem = false;
  selectedAllAnswers = false;
  buttonLabel: string;
  answersDone = false;
  answeredQuestions: Map<Question, Answer> = new Map();
  qList: any;
  questionsList: StandardQuestionModel[];
  responsedQuestions: any;
  alreadyAnsweredError = false;
  isLoaded = false;
  showDots = false;
  modalOpen = false;
  group: any;
  user: any;
  isHead: any = false;
  currentListUsers: any;
  sortOrder: any = {};

  constructor(private userService: UserService,
    private testingService: TestingService,
    private router: Router,
    private modalService: NgbModal,
    public viewDocxService: ViewDocxService,
    public sidebarService: SidebarService,
    private taskBarService: TaskBarService,
    private headerService: HeaderService,
    private testDataService: TestingDataService,
    private adminService: AdminService
  ) { }

  ngOnDestroy() {
    this.testingService.setQuestions(null);
  }

  bitch() {
    this.showDots = true;
    this.selectedAllAnswers = false;
    this.testDataService.data = this.questionsList;
    this.router.navigate(['/dashboard/standards']);
  }

  // @HostListener("window:focus")
  // protected onFocus() {
  //   if (this.modalOpen) {
  //     return
  //   }
  //   if (!this.testDataService.bitchClicked && !this.testDataService.data) {
  //     this.selectedAllAnswers = false;
  //     this.answeredQuestions.clear();
  //     this.getQest();
  //   } else {
  //     this.questionsList = this.testDataService.data;
  //     this.testDataService.data = null;
  //   }
  // }

  downloadFile(id) {
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
        this.errorGetItem = true;
        setTimeout(() => {
          this.errorGetItem = false;
        }, 5000);
      }
    );
  }
  
  setTimeout(arg0: () => void, arg1: number) {
    throw new Error('Method not implemented.');
  }

  isValidYouTubeLink(link: string | undefined | null): boolean {
    if (!link || link.trim() === '' || link.trim() === '" "') {
      return false;
    }

    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/((watch\?v=)?[a-zA-Z0-9_-]{11}|playlist\?list=[a-zA-Z0-9_-]+).*$/;
    return youtubeRegex.test(link.trim());
  }

  sanitizeYouTubeLink(link: string): string {
    if (!link) return '';

    const cleanedLink = link.trim();

    if (!cleanedLink.startsWith('http://') && !cleanedLink.startsWith('https://')) {
      return `https://${cleanedLink}`;
    }

    return cleanedLink;
  }

  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
      this.checkListVectors();
    } else {
      this.isHead = false;
      this.init();
    }
  }

  checkListVectors() {
    this.selectedAllAnswers = false;
    this.showDots = false;
    this.isLoaded = true;
    this.sidebarService.closeSideBar();
    this.taskBarService.closeTaskBar();
    this.headerService.hideSideMenu();
    this.headerService.hideTaskMenu();
    this.headerService.hideUsername();
    this.getAllGroupForListUsers();
  }

  getAllGroupForListUsers(){
    this.adminService.getListLastVector().subscribe(
      (response: any) => {
       const hasUsers = response.body.some(group => group.users.length > 0);
       if (hasUsers) {
        this.currentListUsers = response.body;
        this.currentListUsers.forEach(group => {
          this.sortOrder[group.id] = false;
        });
       } else {
        this.currentListUsers = null;
         this.init();
       }
      },
      (error) => {
        this.init();
      },
    );
  }

  toggleSort(groupId: string) {
    this.sortOrder[groupId] = !this.sortOrder[groupId];
    const group = this.currentListUsers.find(group => group.id === groupId);
    if (group && group.users) {
      group.users.sort((userA, userB) => {
        const fullNameA = `${userA.user.lastName} ${userA.user.firstName} ${userA.user.patronymicName} ${userA.user.fullNativeName || ''}`;
        const fullNameB = `${userB.user.lastName} ${userB.user.firstName} ${userB.user.patronymicName} ${userB.user.fullNativeName || ''}`;
        return this.sortOrder[groupId] ? fullNameA.localeCompare(fullNameB) : fullNameB.localeCompare(fullNameA);
      });
    }
  }


  init() {
    this.selectedAllAnswers = false;
    this.showDots = false;
    this.isLoaded = false;
    this.sidebarService.closeSideBar();
    this.taskBarService.closeTaskBar();
    this.headerService.hideSideMenu();
    this.headerService.hideTaskMenu();
    this.headerService.hideUsername();

    if (JSON.parse(localStorage.getItem('User')).testing === false) {
      this.router.navigate(['/dashboard']);
    }

    this.buttonLabel = 'CHECK_ANSWERS';

    if (this.testingService.getQuestions() !== null) {
      this.questionsList = this.testingService.getQuestions();
      this.answeredQuestions = this.testingService.getAnsweredQuestions();
      this.selectedAllAnswers = this.testingService.getSelectedAllAnswers();
      this.answersDone = this.testingService.getAnswersDone();
      this.buttonLabel = this.testingService.getButtonLabel();
      this.responsedQuestions = this.testingService.getResponsedQuestions();
      this.leaveTesting = this.testingService.leaveTesting;
      this.isLoaded = true;
    } else {
      if (!this.testDataService.data) {
        this.getQest();
      } else {
        this.questionsList = this.testDataService.data;
        this.testDataService.data = null
        this.testDataService.bitchClicked = false;
        this.isLoaded = true;
      }
    }
  }

  getQuestionModel(question: StandardQuestionModel): Question {
    if (!question) {
      return null;
    }
    if (question.question) {
      return question.question;
    }
    return (question as any).questionSpecialization;
  }

  ngOnInit() {
    this.checkRole();
  }

  openNewVectorModal(activeUser) {
    const modalRef = this.modalService.open(VectorValueComponent);
    modalRef.componentInstance.action(activeUser);
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.getAllGroupForListUsers();
      }
    });
  }

  getQest() {
    this.isLoaded = false;
    this.testingService.getQuestionsAPI().subscribe(
      (response: any) => {
        this.isLoaded = true;
        if (response.status === 200) {
          this.questionsList = [];
          if(response.body.questionsStandard) {
            this.questionsList = response.body.questionsStandard;
            this.questionsList.push(...response.body.questionSpecialization);
          } else {
            this.questionsList = response.body
          }
          if (!localStorage.getItem('qList')) {
            this.qList = [];
            this.qList = response.body;
            localStorage.setItem('qList', JSON.stringify(this.qList));
          } else {
            this.qList = [];
            this.qList = JSON.parse('[' + localStorage.getItem('qList') + ']')[0];
          }
        }
        if (response.status === 204) {
          this.errorGetList = true;
          this.answersDone = true;
          this.selectedAllAnswers = true;
          this.buttonLabel = 'CONTINUE';
          this.leaveTesting = true;
          this.testingService.setAnswersDone(true);
          this.testingService.setSelectedAllAnswers(true);
          this.testingService.setButtonLabel('Continue');
          this.testingService.leaveTesting = true;
        }
        this.isLoaded = true;
      }, () => {
        if (this.questionsList == null) {
          this.errorGetList = true;
          this.answersDone = true;
          this.selectedAllAnswers = true;
          this.buttonLabel = 'CONTINUE';
          this.leaveTesting = true;
          this.testingService.setAnswersDone(true);
          this.testingService.setSelectedAllAnswers(true);
          this.testingService.setButtonLabel('Continue');
          this.testingService.leaveTesting = true;
        }
        this.isLoaded = true;
      }, () => {
        this.testingService.setQuestions(this.qList);
        this.isLoaded = true;
      }
    );
    this.testDataService.data = null;
    this.testDataService.bitchClicked = false;
  }

  openPdf(fileId: string) {
    this.userService.getPdf(fileId).subscribe(
      (response: any) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.body], { type: 'application/pdf' }));
        window.open(fileURL, '_blank');
      }
    );
  }

  selectAnswer(question, answer) {
    this.answeredQuestions.set(question, answer);
    if (this.answeredQuestions.size === this.questionsList.length) {
      this.selectedAllAnswers = true;
    }
    this.testingService.addToAnsweredQuestions(question, answer);
  }

  openDocModalDOCX(fileLink) {
    this.modalOpen = true;
    localStorage.setItem('fileLink', fileLink);
    const modalRef = this.modalService.open(ViewDocxComponent, { size: 'lg', backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'Close') {
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
      this.modalOpen = false;
    }, () => {
      this.viewDocxService.deleteLinkByDocxIDManually();
    });
  }

  openDocModal(docxID, sID) {
    this.modalOpen = true;
    localStorage.setItem('DocxID', docxID);
    localStorage.setItem('DocxSID', sID);
    const modalRef = this.modalService.open(ViewDocxComponent, { size: 'lg', backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'Close') {
        this.viewDocxService.deleteLinkByDocxID();
      }
      this.modalOpen = false;
    }, (reason) => {
      this.viewDocxService.deleteLinkByDocxID();
    });
  }

  checkAnswers() {
    this.showDots = true;
    if (this.buttonLabel === 'CONTINUE') {
      this.leaveTesting = true;
      this.testingService.leaveTesting = true;
    }
    if (!this.answersDone && !this.leaveTesting) {
      const answers = new AnsweredQuestions;
      this.answeredQuestions.forEach((value: Answer, key: Question) => {
        answers.addQuestionWithAnswer(new QuestionWithAnswer(value, key));
      });

      this.userService.checkAnswers(answers).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.responsedQuestions = response.body;
            this.answersDone = true;
            this.buttonLabel = 'CONTINUE';
            this.testingService.setAnswersDone(true);
            this.testingService.setButtonLabel('Continue');
            this.testingService.setResponsedQuestions(this.responsedQuestions);
            localStorage.setItem('qList', null);
            if (this.answersDone && this.leaveTesting) {
              const local = this.userService.getLocal();
              local.testing = false;
              this.userService.setLocal(local);
            }
            this.showDots = false;
          } else if (response.status === 208) {
            const local = this.userService.getLocal();
            local.testing = false;
            this.userService.setLocal(local);
            this.leaveTesting = true;
            this.testingService.leaveTesting = true;
            this.showDots = false;
            this.router.navigate(['/dashboard']);
          }
        }, () => {
          this.showDots = false;

        },
      );
    } else {
      this.showDots = false;
      const local = this.userService.getLocal();
      local.testing = false;
      this.userService.setLocal(local);
      this.router.navigate(['/dashboard']);
    }

  }

  isSelectedAndRight(question, answer) {
    for (const respQ of this.responsedQuestions.answeredQuestion) {
      if (this.answeredQuestions.has(question) && respQ.questionText === question.questionText
        && respQ.rightAnswer.answerText === answer.answerText) {
        return true;
      }
    }
    return false;
  }

  isSelectedAndWrong(question, answer) {
    for (const respQ of this.responsedQuestions.failedQuestions) {
      if (this.answeredQuestions.has(question) && this.answeredQuestions.get(question) === answer
        && respQ.questionText === question.questionText
        && respQ.rightAnswer.answerText !== answer.answerText) {
        return true;
      }
    }
    return false;
  }

  isSelected(question, answer) {
    if (this.answeredQuestions.has(question)) {
      return this.answeredQuestions.get(question) === answer;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/testing-page/testing-page.component.ts